export class HookHeader {
  key: string;
  value: string;
  prefix = 'X-<program>';
  is_active = true;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}
